/** @jsx isolateComponent */

import { css } from '@emotion/core';
import { Fragment } from 'react';

import { Colors } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';

const styles = {
  buttonLink: css`
    background: none !important;
    border: none;
    color: ${Colors.ocean};
    padding: 0 !important;
    cursor: pointer;
  `,
};

const views = {
  ['DEFAULT']: () => ({
    bodyText:
      "To create a Zap with more than one action, you'll need a paid plan. Edit your zap or upgrade now to turn on your Zap.",
    type: 'DEFAULT',
    upgradeButtonText: 'Upgrade to Starter',
  }),

  ['DEFAULT_TRIAL_EXTENSION']: ({
    onUpgradeClick,
  }: {
    onUpgradeClick: () => void;
  }) => ({
    bodyText: (
      <Fragment>
        To create a Zap with more than one action, you'll need a paid plan.{' '}
        <strong>Upgrade now</strong> or{' '}
        <strong>
          start a free 7-day trial of the{' '}
          <button css={styles.buttonLink} onClick={onUpgradeClick}>
            Professional plan
          </button>
        </strong>{' '}
        to use multi-step Zaps.
      </Fragment>
    ),
    type: 'DEFAULT_TRIAL_EXTENSION',
    upgradeButtonText: 'Upgrade to Starter',
  }),
};

type Props = {
  canExtendTrial: boolean;
  onUpgradeClick: () => void;
};

export const getActiveView = ({ canExtendTrial, onUpgradeClick }: Props) =>
  canExtendTrial
    ? views.DEFAULT_TRIAL_EXTENSION({
        onUpgradeClick,
      })
    : views.DEFAULT();
